import { useTabNavigation } from "../TabNavigation";
import type { TabViewDisplayProps } from "./TabViewDisplay";
import { TabViewDisplay } from "./TabViewDisplay";

export interface TabViewProps extends Omit<TabViewDisplayProps, "currentTab"> {}

export const TabView = ({ ...rest }: TabViewProps) => {
  const { currentTab } = useTabNavigation();
  return <TabViewDisplay currentTab={currentTab ?? ""} {...rest} />;
};
